import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "scanner-words" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: _ctx.$route.fullPath + '/scanner',
      tag: "button",
      class: "modal-button__run scanner-words__btn"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.Ti18N("account.scannerButton")), 1)
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}